<template>
    <portal>
        <div class="mb-8 d-flex align-center">
            <v-icon color="primary" size="30">mdi-cash-usd-outline</v-icon>
            <h1 class="headline ml-4 font-weight-bold grey--text--darken-2 text-uppercase">Investment Options</h1>
        </div>
        <v-row class="mb-6">
            <v-col>
                <p>Select the portfolio you would like to learn more about by clicking on the icon below.</p>
            </v-col>
        </v-row>
        <v-row>
            <v-col class="investment-op-first">
                <v-card elevation="0" color="transparent">
                    <v-card-text align="center">
                        &nbsp;
                    </v-card-text>
                </v-card>
            </v-col>
            <v-col class="investment-op-others">
                <v-card elevation="0" color="transparent" class="investment-op-label">
                    <v-card-text class="d-flex">
                        <v-icon size="40">mdi-chevron-left</v-icon>
                        <span align="left" >Lower<br>Risk</span>
                    </v-card-text>
                </v-card>
            </v-col>
            <v-col class="investment-op-others">
                <v-card elevation="0" color="transparent">
                    <v-card-text align="center">
                        &nbsp;
                    </v-card-text>
                </v-card>
            </v-col>
            <v-col class="investment-op-others">
                <v-card elevation="0" color="transparent" class="investment-op-label">
                    <v-card-text class="d-flex justify-end">
                        <span align="right">Higher<br>Risk</span>
                        <v-icon size="40">mdi-chevron-right</v-icon>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
        <v-row>
            <v-col class="investment-op-first">
                <v-card elevation="0" color="transparent" class="investment-op-label">
                    <v-card-text class="d-flex flex-column align-center">
                        <v-icon size="40">mdi-chevron-up</v-icon>
                        <span align="center">Least<br>Cost</span>
                    </v-card-text>
                </v-card>
            </v-col>
            <v-col class="investment-op-others">
                <v-card color="colorScale1">
                    <v-card-title class="font-weight-regular d-flex align-center justify-center">
                        Calm
                    </v-card-title>
                    <v-card-text align="center">
                        <v-btn outlined rounded>
                            <v-icon>mdi-download</v-icon>
                        </v-btn>
                    </v-card-text>
                </v-card>
            </v-col>
            <v-col class="investment-op-others">
                <v-card color="colorScale2">
                    <v-card-title class="font-weight-regular d-flex align-center justify-center">
                        Growth
                    </v-card-title>
                    <v-card-text align="center">
                        <v-btn outlined rounded>
                            <v-icon>mdi-download</v-icon>
                        </v-btn>
                    </v-card-text>
                </v-card>
            </v-col>
            <v-col class="investment-op-others">
                <v-card color="colorScale4">
                    <v-card-title class="font-weight-regular d-flex align-center justify-center">
                        Turbo
                    </v-card-title>
                    <v-card-text align="center">
                        <v-btn outlined rounded>
                            <v-icon>mdi-download</v-icon>
                        </v-btn>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
        <v-row>
            <v-col class="investment-op-first">
                <v-card elevation="0" color="transparent">
                    <v-card-text align="center">
                        &nbsp;&nbsp;
                    </v-card-text>
                </v-card>
            </v-col>
            <v-col class="investment-op-others">
                <v-card color="colorScale2">
                    <v-card-title class="font-weight-regular d-flex align-center justify-center">
                        Income
                    </v-card-title>
                    <v-card-text align="center">
                        <v-btn outlined rounded>
                            <v-icon>mdi-download</v-icon>
                        </v-btn>
                    </v-card-text>
                </v-card>
            </v-col>
            <v-col class="investment-op-others">
                <v-card color="colorScale3">
                    <v-card-title class="font-weight-regular d-flex align-center justify-center">
                        Balance
                    </v-card-title>
                    <v-card-text align="center">
                        <v-btn outlined rounded>
                            <v-icon>mdi-download</v-icon>
                        </v-btn>
                    </v-card-text>
                </v-card>
            </v-col>
            <v-col class="investment-op-others">
                <v-card color="colorScale5">
                    <v-card-title class="font-weight-regular d-flex align-center justify-center">
                        Equity/Dividends
                    </v-card-title>
                    <v-card-text align="center">
                        <v-btn outlined rounded>
                            <v-icon>mdi-download</v-icon>
                        </v-btn>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
        <v-row>
            <v-col class="investment-op-first investment-op-last-item">
                <v-card elevation="0" color="transparent" class="investment-op-label">
                    <v-card-text class="d-flex flex-column align-center">
                        <span align="center">Most<br>Active</span>
                        <v-icon size="40">mdi-chevron-down</v-icon>
                    </v-card-text>
                </v-card>
            </v-col>
            <v-col class="investment-op-others">
                <v-card color="colorScale4">
                    <v-card-title class="font-weight-regular d-flex align-center justify-center">
                        Tatical-30
                    </v-card-title>
                    <v-card-text align="center">
                        <v-btn outlined rounded>
                            <v-icon>mdi-download</v-icon>
                        </v-btn>
                    </v-card-text>
                </v-card>
            </v-col>
            <v-col class="investment-op-others">
                <v-card color="colorScale5">
                    <v-card-title class="font-weight-regular d-flex align-center justify-center">
                        Tatical-45
                    </v-card-title>
                    <v-card-text align="center">
                        <v-btn outlined rounded>
                            <v-icon>mdi-download</v-icon>
                        </v-btn>
                    </v-card-text>
                </v-card>
            </v-col>
            <v-col class="investment-op-others">
                <v-card color="colorScale6">
                    <v-card-title class="font-weight-regular d-flex align-center justify-center">
                        Tatical-60
                    </v-card-title>
                    <v-card-text align="center">
                        <v-btn outlined rounded>
                            <v-icon>mdi-download</v-icon>
                        </v-btn>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
    </portal>
</template>

<script>
    import Portal from "@/components/Portal";
    import {mapGetters} from "vuex";
    import axios from "axios";
    import Echo from "laravel-echo";

    export default {
        name: "InvestmentOptions",
        components: {
            Portal
        },
        computed: {
            ...mapGetters('auth', [

            ]),
        },
        data() {
            return {
                checkedSubsections: [],
                emailReport: {
                    enabled: false,
                    frequency: 0,
                },
                reportLoading: false,
                frequencies: [
                    {name: 'Daily', value: 0},
                    {name: 'Weekly', value: 1},
                    {name: 'Monthly', value: 2},
                ],
            }
        },
        mounted() {
            if (! this.user.has_external_household) {
                this.$router.push({ name: 'GetStarted' });
                return;
            }

            axios.get('/api/household/' + this.user.household_id + '/export-email-reports')
                .then(response => {
                    this.emailReport = response.data.data.email_report;
                });

            window.io = require('socket.io-client');

            window.Echo = new Echo({
                broadcaster: 'socket.io',
                host: process.env.VUE_APP_ECHO_URL
            });

            window.Echo.channel('export-complete.' + this.user.household_id)
                .listen('.Household\\Events\\ExportCompleteEvent', (e) => {
                    this.reportLoading = false;
                    window.location = process.env.VUE_APP_BASE_URL + '/exports/' + e.id + '/download';
                });
        },
        methods: {
            saveEmailReport: function() {
                axios.post('/api/household/' + this.user.household_id + '/export-email-reports', {
                    email_reports: this.emailReport.enabled,
                    frequency: this.emailReport.frequency,
                }, { showLoader: false });
            },
            processForm: function() {
                axios.post('/api/household/' + this.user.household_id + '/client-accounts-reports')
                    .then(() => {
                        this.reportLoading = true;
                    });
            }
        }
    }
</script>

<style scoped>

.investment-op-first {
    width: 10%;
    flex-basis: auto;
    flex-grow: unset;
}

.investment-op-others {
    width: 30%;
    flex-basis: auto;
    flex-grow: unset;
}

.investment-op-label .v-card__text {
    padding: 0 !important;
}

.investment-op-last-item {
    display: flex;
    align-items: flex-end;
    justify-content: center;

}

</style>
